import Axios from "axios";

export default function DMeritListDetail(catId,year,typeId,entranceId){
     //console.log(appliedCounsellingId);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a:'dmeritDetail',
            catId,
            year,
            typeId,
            entranceId
          
        }
    });
    return response;
}